import { FormSection, FormSectionRow } from '@strata/react-form-section';
import { ProgressBar } from '@strata/react-progress-bar';
import { PerformanceStatusIndicator } from '@strata/react-status-indicators';
import classNames from 'classnames';

import { PerformanceRequirement } from 'api/performanceAPI';
import { PerformanceComponent } from 'components/wonReferrals/PerformanceComponent';

interface PerformanceProgressProps {
    performanceEntries?: PerformanceRequirement[];
}

export const PerformanceProgress = ({
    performanceEntries = undefined,
}: PerformanceProgressProps) => {
    // calc total & completed incentive amounts
    let incentiveTotal = 0;
    let incentiveComplete = 0;
    performanceEntries?.forEach((entry) => {
        incentiveTotal += entry.incentive ?? 0;
        if (entry.status === PerformanceStatusIndicator.Statuses.SUCCESSFUL) {
            incentiveComplete += entry.incentive ?? 0;
        }
    });

    return (
        <FormSection
            sectionTitle="Performance Progress"
            content={
                <>
                    {incentiveTotal > 0 && (
                        <FormSectionRow
                            rowContent={
                                <div style={{ width: 'auto' }} className="margin__top--medium">
                                    <ProgressBar
                                        completed={incentiveComplete}
                                        total={incentiveTotal}
                                        labelText="Achieved"
                                        dollarSign
                                    />
                                </div>
                            }
                        />
                    )}
                    {performanceEntries?.map((performanceEntry, index) => (
                        <div
                            className={classNames({
                                'padding__bottom--medium': index < performanceEntries.length - 1,
                            })}
                            key={performanceEntry.value_case_id}
                        >
                            <PerformanceComponent
                                key={performanceEntry.value_case_id}
                                performanceRequirement={performanceEntry}
                            />
                        </div>
                    ))}
                </>
            }
        />
    );
};
